import { getJSON } from './featureFlagBrowserClient';

const isContextualChatEnabled = (userMlsTypes: string[]): boolean => {
  const { enabled, enabledMlsTypes } = getJSON('contextualChat') ?? {};

  if (!enabled || !Array.isArray(enabledMlsTypes) || !enabledMlsTypes.length)
    return false;

  const mlsTypes = userMlsTypes.map(mls => mls.toLocaleLowerCase()) || [];
  return enabledMlsTypes.some(mls =>
    mlsTypes.includes(mls.toLocaleLowerCase()),
  );
};

export default isContextualChatEnabled;
